import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
          {t('cta.title')}
        </h2>
        <p className="text-foreground-500 text-sm md:text-base mb-8">
          {t('cta.subtitle')}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-label text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          {t('cta.button')}
          <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>

      {/* Bottom product banner */}
      <div className="mt-16 max-w-6xl mx-auto">
        <div className="flex flex-wrap justify-center gap-4">
          <img
            src="https://readdy.ai/api/search-image?query=Vintage%20round%20tortoiseshell%20sunglasses%20with%20gold%20metal%20accents%20on%20sunlit%20marble%20surface%2C%20soft%20afternoon%20light%20creating%20warm%20reflections%2C%20luxury%20accessory%20photography%2C%20Mediterranean%20summer%20aesthetic%20with%20gentle%20shadows&width=200&height=200&seq=banner-prod-1-v2-2026&orientation=squarish"
            alt="Prodotto Itaobuy"
            className="w-32 h-32 md:w-40 md:h-40 rounded-2xl object-cover bg-background-100"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Handcrafted%20woven%20leather%20sandals%20with%20braided%20straps%20on%20warm%20terracotta%20tiles%2C%20soft%20golden%20hour%20sunlight%2C%20artisanal%20Mediterranean%20craftsmanship%20photography%2C%20rustic%20elegant%20aesthetic%20with%20natural%20textures&width=200&height=200&seq=banner-prod-2-v2-2026&orientation=squarish"
            alt="Prodotto Itaobuy"
            className="w-32 h-32 md:w-40 md:h-40 rounded-2xl object-cover bg-background-100"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20silk%20scarf%20with%20hand%20painted%20floral%20pattern%20draped%20on%20vintage%20wooden%20surface%2C%20soft%20diffused%20window%20light%2C%20luxury%20accessory%20still%20life%20photography%2C%20timeless%20Parisian%20boutique%20aesthetic%20with%20gentle%20shadows&width=200&height=200&seq=banner-prod-3-v2-2026&orientation=squarish"
            alt="Prodotto Itaobuy"
            className="w-32 h-32 md:w-40 md:h-40 rounded-2xl object-cover bg-background-100"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Structured%20vegan%20leather%20backpack%20in%20warm%20cognac%20tone%20on%20cream%20linen%20background%2C%20soft%20studio%20lighting%2C%20modern%20minimalist%20accessory%20photography%2C%20Scandinavian%20design%20aesthetic%20with%20clean%20lines%20and%20subtle%20shadows&width=200&height=200&seq=banner-prod-4-v2-2026&orientation=squarish"
            alt="Prodotto Itaobuy"
            className="w-32 h-32 md:w-40 md:h-40 rounded-2xl object-cover bg-background-100"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Fine%20merino%20wool%20beanie%20with%20subtle%20ribbed%20texture%20on%20warm%20wooden%20surface%2C%20soft%20candlelit%20ambiance%2C%20cozy%20winter%20accessory%20photography%2C%20hygge%20aesthetic%20with%20gentle%20warm%20tones%20and%20delicate%20shadows&width=200&height=200&seq=banner-prod-5-v2-2026&orientation=squarish"
            alt="Prodotto Itaobuy"
            className="w-32 h-32 md:w-40 md:h-40 rounded-2xl object-cover bg-background-100"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Artisanal%20ceramic%20perfume%20bottle%20with%20hand%20painted%20botanical%20details%20on%20sunlit%20windowsill%2C%20soft%20morning%20light%20filtering%20through%20sheer%20curtains%2C%20natural%20fragrance%20product%20photography%2C%20poetic%20still%20life%20aesthetic%20with%20fresh%20herbs%20nearby&width=200&height=200&seq=banner-prod-6-v2-2026&orientation=squarish"
            alt="Prodotto Itaobuy"
            className="w-32 h-32 md:w-40 md:h-40 rounded-2xl object-cover bg-background-100"
          />
        </div>
      </div>
    </section>
  );
}